import { getProductCategoriesAmount } from './getProductCategoriesAmount';
import { getProductsAmount } from './getProductsAmount';

export const ProductsService = {
  getProductCategoriesAmount,
  getProductsAmount,
};
